import { render, staticRenderFns } from "./NotificationItem-min.vue?vue&type=template&id=24e4afea&"
import script from "./NotificationItem-min.vue?vue&type=script&lang=js&"
export * from "./NotificationItem-min.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports